const rules = {}

rules.required = (value) => !!(value && value.toString().trim()) || 'Campo requerido';

rules.noEdgeSpaces = (value) =>
  (value || '') === (value || '').trim() || 'No debe iniciar ni terminar en espacio';

rules.onlyNumbers = (value) => {
  const reg = /^[0-9]*$/
  return reg.test(String(value)) || 'Solo números'
}

rules.onlyNumbersAndDots = (value) => {
  if (value === undefined || value === null || value === "")
    return true; // Permitir vacío
  const pattern = /^[0-9.,]+$/;
  return pattern.test(value) || "Solo se permiten números";
}

rules.phoneNumber = (value) => {
  if(!value) return true
  if((value.length <= 6) && (value.length > 0)) {
    return 'Número no valido' ;
  } else {
    return true
  }
}

rules.phone = (value) => (value && (value.length == 10 || value.length == 12) ) || "Ingrese un número de celular";

rules.email = (v) => {
  if (/\s/.test(v)) return "El correo no debe contener espacios";
  return /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || "Correo inválido";
};

rules.strongPassword = (v) =>
  /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(v || "") ||
  "Mínimo 8 caracteres, una mayúscula, un número y un carácter especial";

rules.minCharactersNit = (value = '') => value?.length >= 6 || "Mínimo 6 caracteres";

rules.minCharactersDefault = (value = '') => value?.length >= 5 || "Minimo 5 caracteres";

rules.maxSize = (value) => {
  // Si no hay archivo cargado, pasa la validación
  if (!value) return true
  // value puede ser File o Array (si multiple está activado)
  const file = Array.isArray(value) ? value[0] : value
  // 5 MB en bytes
  const maxSize = 5 * 1024 * 1024
  return file.size <= maxSize || 'El archivo no debe superar los 5 MB'
}

rules.lengthArea = (value) => {
  if (value?.length < 20 || value?.length > 250) {
    return "El texto debe tener entre 20 y 250 caracteres";
  }
  return true;
}

rules.maxLength = (value) => {
  if (value?.length < 20 || value?.length > 150) {
    return "El texto debe tener entre 20 y 150 caracteres";
  }
  return true;
}

rules.minLength = (value) => (value || "").length >= 30 || "Longitud miníma exigida es de (30)."

rules.maxFiveDigits = (value) => {
  if (!value) return true
  return value.toString().length <= 5 || 'Máximo 5 dígitos'
}

rules.requiredDate = (value) => {
  if (value) return true
  else if (this.idrecogida) return true
  else return "Debes seleccionar una fecha o un número de solicitud"
}

rules.minPrice = (value) => {
  return value >= 1 || "El valor de tu envío debe ser mayor a $1";
}

rules.minValue = (value) => {
  return value >= 1 || "El valor debe ser mayor o igual a 1";
}

rules.cellphoneNumber = (value) => {
  if(!value) return true

  const mobilPrefix = [
  300, 301, 302, 305, 310, 311, 312, 313, 314, 320, 321,
  322, 323, 315, 316, 317, 318, 319, 350, 351, 304, 324, 304,
  330, 331, 332, 333, 334, 335 ];

  let prefix = value.substring(0,3)
  let initVal = value.substring(0,2)

  if(value.length <= 9 && (value.length > 0)) return 'Número no valido';
  if((value.length <= 6) && (value.length > 0)) {
    return 'Número no valido' ;
  } else if(!mobilPrefix.includes( parseInt(prefix)) && value.length == 10 && initVal != 60) {
    return 'Prefijo invalido';
  } else {
    return true
  }
}

export default rules;